import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c107382"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dashboard-head"
};
const _hoisted_2 = {
  class: "head-title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "head-status"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "head-status__dot"
}), /*#__PURE__*/_createElementVNode("span", null, "系统在线")], -1));
const _hoisted_4 = {
  class: "head-clock"
};
const _hoisted_5 = {
  class: "head-clock__date"
};
const _hoisted_6 = {
  class: "head-clock__time"
};
const _hoisted_7 = {
  class: "head-clock__week"
};
import { computed, onMounted, onUnmounted, ref } from "vue";
export default {
  __name: 'index',
  props: {
    title: {
      type: String,
      default: "电推进真空环境模拟系统"
    }
  },
  setup(__props) {
    const now = ref(new Date());
    let timer = null;
    const dateText = computed(() => {
      const current = now.value;
      const year = current.getFullYear();
      const month = String(current.getMonth() + 1).padStart(2, "0");
      const day = String(current.getDate()).padStart(2, "0");
      return `${year}.${month}.${day}`;
    });
    const timeText = computed(() => {
      const current = now.value;
      const hour = String(current.getHours()).padStart(2, "0");
      const minute = String(current.getMinutes()).padStart(2, "0");
      const second = String(current.getSeconds()).padStart(2, "0");
      return `${hour}:${minute}:${second}`;
    });
    const weekText = computed(() => {
      const weekMap = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
      return weekMap[now.value.getDay()];
    });
    onMounted(() => {
      timer = setInterval(() => {
        now.value = new Date();
      }, 1000);
    });
    onUnmounted(() => {
      if (timer) {
        clearInterval(timer);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("header", _hoisted_1, [_createElementVNode("h1", _hoisted_2, _toDisplayString(__props.title), 1), _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(dateText.value), 1), _createElementVNode("strong", _hoisted_6, _toDisplayString(timeText.value), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(weekText.value), 1)])]);
    };
  }
};